/*******
 * 
 * author: Sutherland Nele, Platform Pacific Limited
 * 
 * purpose: Simple custom React Hook to check device type accessing the client browser app
 * 
 ****/

import React from "react";

export default function useDeviceDetect() {
  const [deviceType, setDeviceType] = React.useState("");

  React.useEffect(() => {
    const ua =  typeof window.navigator === "undefined" ? "" : navigator.userAgent;

    if(ua === ""){
        throw new Error("useDeviceDetect hook cannot work as this is server-side Javascript!");
    }

    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        setDeviceType("tablet");
    }
    else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        setDeviceType("mobile");
    }
    else
    {
        setDeviceType("desktop");
    }



  }, []);

  return { deviceType };
}
